<template>
    <simple-layout
        :models-loaded="true"
        name="Users"
        imgPosY="-300"
    >
        <h1>Utilisateurs</h1>
        <model-manager :model-to-manage='modelToManage'></model-manager>
    </simple-layout>
</template>

<script>
import ModelManager from 'fundation-app-vuejs/src/components/partials/ModelManager';
export default {

    name: 'Index',
    components:{
        ModelManager,
    },
    data () {
        return {
            modelToManage: {
                modelName: 'grantedAccessUser',
                modelUrl: 'granted-access-user/',
                modelVerboseName: 'un utilisateur',
                representationField: 'nni',
                defaultCreationParams: {},
                defaultPatchParams: {},
                hasChildModel: false,
                archiveOnDelete: false,
                fields: [
                    {
                        fieldKey: 'nni',
                        fieldVerbose: 'Nni',
                        displayTable: true,
                        displayDetails: true,
                        displayForm: true,
                        columnSortable: true,
                        formRequired: true,
                        dataPosition: 1,
                        fieldType: 'string',
                    },
                    {
                        fieldKey: 'actions',
                        fieldVerbose: 'Opérations',
                        displayTable: true,
                        displayDetails: false,
                        displayForm: false,
                        fieldType: 'actions',
                        canEdit: false,
                        canDelete: true,
                    },
                ],
            },
        };
    },
    methods: {
    }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/User/index.vue